import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonSecondary, Modal, colors } from '@aftersale-next/ui';
import { useEffect } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { RetentionWithBonus } from '@aftersale-next/retention';
import { useTimelineOccurrence } from '../../hooks/use-timeline-occurrence';
import { formatMoney } from '@aftersale-next/utils';
export default function ActionRefuseRetention(_ref) {
  var isLoading = _ref.isLoading,
      mutate = _ref.mutate,
      id = _ref.id,
      isError = _ref.isError,
      isSuccess = _ref.isSuccess,
      reset = _ref.reset;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var occurrence = useTimelineOccurrence();
  var packageValue = formatMoney(occurrence === null || occurrence === void 0 ? void 0 : occurrence.totalPackageValue);

  var handleClose = function handleClose() {
    if (isLoading) return;
    if (isError) reset();
    onClose();
  };

  var handleConfirm = function handleConfirm(trackingAction) {
    mutate({
      action: trackingAction,
      id: id
    });
  };

  useEffect(function () {
    if (!isSuccess) return;
    onClose();
  }, [isSuccess, onClose]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonSecondary, {
      id: 'refuse-retention',
      disabled: isLoading,
      bgColor: "none",
      borderColor: colors.green,
      textColor: colors.green,
      onClick: onOpen,
      children: t('ACTION_REFUSE_RETENTION')
    }), /*#__PURE__*/_jsx(Modal, {
      isOpen: isOpen,
      onClose: handleClose,
      children: /*#__PURE__*/_jsx(RetentionWithBonus, {
        totalPackageValue: packageValue,
        isError: isError,
        isLoading: isLoading,
        onClose: onClose,
        onConfirm: handleConfirm
      })
    })]
  });
}